import { MAP_STATUS_FROM_PV_TO_CONEXA } from './constants'
import { ConexaConsultationStatus, PVConsultationStatus } from './types'

export const mapStatusFromPvToConexa = (
  value: PVConsultationStatus,
): ConexaConsultationStatus => {
  return MAP_STATUS_FROM_PV_TO_CONEXA[value]
}
